import React, { createContext, useContext, useEffect, useState } from "react";

const LangContext = createContext(null);
const STORAGE_KEY = "orion_lang";
export const LANGS = [
  { code: "pt", label: "PT", full: "Português",  flag: "🇧🇷", rtl: false },
  { code: "en", label: "EN", full: "English",    flag: "🇺🇸", rtl: false },
  { code: "es", label: "ES", full: "Español",    flag: "🇪🇸", rtl: false },
  { code: "ar", label: "AR", full: "العربية",     flag: "🇸🇦", rtl: true  },
  { code: "ja", label: "JA", full: "日本語",       flag: "🇯🇵", rtl: false },
  { code: "ko", label: "KO", full: "한국어",       flag: "🇰🇷", rtl: false },
  { code: "zh", label: "ZH", full: "中文",         flag: "🇨🇳", rtl: false },
];

export function LangProvider({ children }) {
  const [lang, setLangState] = useState(() => {
    if (typeof window === "undefined") return "pt";
    return window.localStorage.getItem(STORAGE_KEY) || "pt";
  });

  const setLang = (code) => {
    setLangState(code);
    try {
      window.localStorage.setItem(STORAGE_KEY, code);
    } catch {}
  };

  useEffect(() => {
    const meta = LANGS.find((l) => l.code === lang) || LANGS[0];
    document.documentElement.setAttribute("lang", lang === "pt" ? "pt-BR" : lang);
    // Apply RTL only on the article-body element so admin/other pages
    // don't flip. Article.jsx toggles [dir] on the article root.
    if (meta.rtl) document.body.setAttribute("data-rtl", "1");
    else document.body.removeAttribute("data-rtl");
  }, [lang]);

  return (
    <LangContext.Provider value={{ lang, setLang, LANGS }}>
      {children}
    </LangContext.Provider>
  );
}

export function useLang() {
  const ctx = useContext(LangContext);
  if (!ctx) return { lang: "pt", setLang: () => {}, LANGS };
  return ctx;
}
